<script lang="ts">
	import { onMount } from 'svelte';
	import type { Readable } from 'svelte/store';
	import { Editor, EditorContent } from 'svelte-tiptap';
	import type { MentionOptions } from '@tiptap/extension-mention';
	import { allBlocks } from '$textEditor/Components/Popovers/InsertBlock/InsertBlock.svelte';
	import Mentions from '$textEditor/Components/Popovers/Mention/Mentions.svelte';
	import createDefaultEditor from '$textEditor/createDefaultEditor';
	import { LineFormatingPopover } from '$textEditor/Components/Popovers';
	import SelectionPopover from '$textEditor/Components/Popovers/Selection/SelectionPopover.svelte';
	import InsertBlock from '$textEditor/Components/Popovers/InsertBlock/InsertBlock.svelte';
	import '$lib/components/Post/PostBlock/Blocks/text.css';

	export let editor: Readable<Editor>;
	export let enabledBlocks = allBlocks;
	let mentionsTipTap: MentionOptions['suggestion'];

	const randomId = Math.random().toString(36).substring(7);

	onMount(() => {
		editor = createDefaultEditor(mentionsTipTap, randomId);
		setTimeout(() => $editor.commands.focus());
	});
</script>

<Mentions bind:mentionsTipTap />
<div>
	<div id={`editorWrapper-${randomId}`}>
		{#if editor && $editor}
			<EditorContent editor={$editor} />
		{/if}
		<div id={`InsertBlock-${randomId}`}>
			<InsertBlock editor={$editor} {enabledBlocks} />
		</div>
		<div id={`selectionPopover-${randomId}`}>
			<SelectionPopover editor={$editor} />
		</div>
		<div id={`lineFormating-${randomId}`}>
			<LineFormatingPopover editor={$editor} />
		</div>
	</div>
</div>

<style>
	[id^='editorWrapper'] {
		padding-block-end: 10px;
		padding-inline: 50px;
		overflow: auto;
	}
</style>
